import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store, select } from '@ngrx/store';

import * as ApplyPromoCodeActions from './promo-code.actions';
import { PromoCodeDialogAction } from './promo-code.actions';
import * as ApplyPromoCodeSelectors from './promo-code.selectors';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Injectable()
export class ApplyPromoCodeFacade {
  /**
   * Combine pieces of state using createSelector,
   * and expose them as observables through the facade.
   */
  isApplying$ = this.store.pipe(select(ApplyPromoCodeSelectors.isApplying));

  isApplyingSuccess$ = this.store.pipe(
    select(ApplyPromoCodeSelectors.isApplyingSuccess),
  );

  loaded$ = this.store.pipe(select(ApplyPromoCodeSelectors.getPromoCodeLoaded));

  error$ = this.store.pipe(select(ApplyPromoCodeSelectors.getPromoCodeError));

  promoCode$ = this.store.pipe(select(ApplyPromoCodeSelectors.getPromoCode));

  constructor(
    private readonly store: Store,
    private dialog: MatDialog,
  ) {}

  /**
   * Init promo code
   * @param promoCode
   */
  init() {
    this.store.dispatch(ApplyPromoCodeActions.loadPromoCode());
  }

  /**
   * Save promo code
   */
  savePromoCode(data: { promoCode: string }) {
    this.store.dispatch(
      ApplyPromoCodeActions.savePromoCode({
        promoCode: data.promoCode,
      }),
    );
  }

  /**
   * Remove promo code
   */
  removePromoCode(options?: { force?: boolean }) {
    this.store.dispatch(
      ApplyPromoCodeActions.removePromoCode({
        options,
      }),
    );
  }

  /**
   * Add promo code
   */
  addPromoCode(payload?: { promoCode?: string }) {
    // TODO: check if is deprecated
  }

  openPromoCodeDialog(payload?: { promoCode?: string; source?: string }) {
    this.store.dispatch(
      PromoCodeDialogAction.openDialog('', {
        source: payload?.source || 'click',
      }),
    );
  }
}
